export default "__VITE_ASSET__9aace375__"